import script from "./InvitationForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvitationForm.vue?vue&type=script&lang=ts&setup=true"

import "./InvitationForm.vue?vue&type=style&index=0&id=f7a5fe1c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7a5fe1c"]])

export default __exports__